import { MONTIPLAYER_ACTION_TYPES } from './montiplayerActions'

export const STATE_KEY = 'montiplayer'

const INITIAL_STATE = {
  players: [],
  isInitialized: false,
  sdkLoading: false,
}

function sdkLoaded(state) {
  return { ...state, ...{ isInitialized: true } }
}

function sdkStartLoading(state) {
  return { ...state, ...{ sdkLoading: true } }
}

const handlers = {
  [MONTIPLAYER_ACTION_TYPES.SDK_LOADED]: sdkLoaded,
  [MONTIPLAYER_ACTION_TYPES.LOAD_SDK]: sdkStartLoading,
}

export function isInitializedSelector(state) {
  return state[STATE_KEY].isInitialized
}

export function sdkLoadingStateSelector(state) {
  return state[STATE_KEY].sdkLoading
}

export function montiReducer(state = INITIAL_STATE, action) {
  return (handlers[action.type] && handlers[action.type](state, action.payload)) || state
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/monti/montiReducer.js